import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-rate" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "subText" }
const _hoisted_5 = { class: "rate-container" }
const _hoisted_6 = { class: "rate-title" }
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "currency-symbol" }, "$", -1 /* HOISTED */)
const _hoisted_9 = { class: "input-hint" }
const _hoisted_10 = { class: "input-hint" }
const _hoisted_11 = { class: "bottom-description description" }
const _hoisted_12 = { class: "subText" }
const _hoisted_13 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString($setup.text.getPaid), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString($setup.text.optCreates), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString($setup.text.yourStRate), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["payment-container shift-left", `.text-width-${$setup.costLength}`])
        }, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            class: "payment-amount",
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.amount) = $event)),
            min: "defaults.price.min",
            max: "defaults.price.max"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.amount]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("span", _hoisted_9, _toDisplayString($setup.text.editStMtgRt + " " + $setup.text.price), 1 /* TEXT */),
        _createElementVNode("div", {
          class: _normalizeClass(["payment-container", `.text-width-${$setup.durationLength}`])
        }, [
          _withDirectives(_createElementVNode("input", {
            class: "payment-amount",
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.minutes) = $event)),
            min: "defaults.length.min",
            max: "defaults.length.max"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.minutes]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.text.editStMtgRt + " " + $setup.text.duration), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, _toDisplayString($setup.text.thisWillBe), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        class: "outline save-amount",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateDefaultRate()))
      }, "Save Amount"),
      _createVNode($setup["BackButton"], { onClickedback: $setup.clickedBackButton })
    ]),
    ($setup.loading)
      ? (_openBlock(), _createBlock($setup["VLoader"], {
          key: 0,
          "full-screen": true
        }))
      : _createCommentVNode("v-if", true)
  ]))
}